import React from 'react';

import abLogo from '../logos/ABLogo.svg';

export const ABLogo = () => {
  return <img alt='ABLogo' src={abLogo} />;
};
